import React from "react";
import "./index.css";
import MyAnimation from "./anm";

function App() {
  return (
    <body className="w-full min-h-screen bg-black flex items-center justify-center">
      <div
        className="w-96 h-96
          rounded-3xl flex-col bg-white shadow-lg transition-all duration-500 transform group
          hover:shadow-2xl hover:scale-105 hover:bg-gradient-to-t hover:from-slate-900 hover:to-black hover:animate-pulse
          flex items-center justify-center
          p-4"
        onMouseMove={() => document.body.classList.add("bg-slate-800")}
        onMouseLeave={() => document.body.classList.remove("bg-slate-800")}
      >
        <div>
          <MyAnimation />
          <h1
            className="
              text-black md:w-3/4
              sm:w-1/2
              max-w-sm
              fixed font-bold
              top-3/4 left-1/2 -translate-x-1/2 -translate-y-1/2
              flex items-center justify-center animate-pulse
              group-hover:hidden
            "
          >
            Answer a Call !!
          </h1>
        </div>
        <div className="hidden group-hover:flex w-full h-full items-center justify-center">
          <div
            className="
              w-full sm:w-3/4 md:w-2/3 lg:w-1/2
              max-w-md
              flex flex-col items-center justify-center
              text-center
              px-2
            "
          >
            <img
              src="https://avatars.githubusercontent.com/u/130164815?v=4"
              className="w-20 h-20 rounded-full mb-10 md:mb-16 lg:mb-20"
              alt="Profile Avatar"
            ></img>
            <h1 className="text-white text-wrap font-thin text-sm sm:text-base md:text-lg">
              {" "}
              <span className="typing-animation">[+]My name is Abdulaziz</span>
              <br />
              <span className="typing-animation">[+]Now you know who I`m</span>
              <br />
              <span className="typing-animation">[+]Who is calling you?</span>
              <br />
              <span className="typing-animation">
                [+]Use my tools to find out
              </span>
              <br />
              <span className="typing-animation">
                [+]You can find me on GitHub
              </span>
              <br />
              <span className="typing-animation">
                [+]
                <a
                  href="https://github.com/vuvvvv/MuraqibKsa"
                  className="text-blue-500 animate-pulse"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click Here
                </a>
              </span>
              <br />
            </h1>
          </div>
        </div>
      </div>
    </body>
  );
}

export default App;
